import React from 'react';

const HomeMainPCHelpDesk = () => {
  return <p className="custom-tel">시스템헬프데스크 : 1899 - 3899</p>;
};

export default HomeMainPCHelpDesk;
